'use client';

var translations = {
    'Tạo hồ sơ ấn tượng với WowCV': 'Create attracted CV with WowCV',
    'Xem mẫu thư giới thiệu': 'View sample',
    'Thư giới thiệu': 'Cover letter',
    'Thư giới thiệu (Không bắt buộc)': 'Cover letter (Optional)',
    'Nhà tuyển dụng ưu tiên hồ sơ ứng tuyển viết bằng': 'Employers prefer to receive your resume in',
    'Hồ Sơ VietnamWorks': 'VietnamWorks Profile',
    'Hồ Sơ Đính Kèm': 'Attached CV',
    'Hồ Sơ Vừa Tải Lên': 'CV Just Uploaded',
    'Đã tải lên': 'Uploaded',
    'hoàn thiện': 'completed',
    'Chọn hồ sơ từ máy của bạn': 'Upload file from your device',
    'Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB': '.doc, .docx and .pdf files that are less than 5120KB in size',
    'Nộp Đơn': 'Send application',
    'Vui lòng nhập thông tin.': 'This field is required.',
    'Vui lòng không nhập số điện thoại hoặc email.': 'Please do not enter phone number or email.',
    'Vui lòng không nhập kí tự đặc biệt.': 'Please do not enter special characters.',
    'Nhập thư giới thiệu': 'Enter cover letter',
    'Nhập chức danh': 'Enter job title',
    'Nhập số điện thoại': 'Enter phone number',
    'Cho phép Nhà tuyển dụng tìm kiếm': 'Allow Employers to search',
    'Chọn hồ sơ ứng tuyển': 'Choose a profile to apply',
    Resume: 'Resume',
    'Xem hồ sơ': 'View profile',
    'Không bắt buộc': 'Optional',
    'ho-so': 'my-profile',
    'thiet-lap-ho-so': 'profile-settings',
    'quan-ly-nghe-nghiep': 'my-career-center',
    'Thiết lập hồ sơ': 'Profile settings',
    'Hồ sơ của tôi': 'My Profile',
    'Đã có sự cố kỹ thuật trong khi xử lý yêu cầu của bạn. Vui lòng chờ 5 phút và thử lại hoặc liên hệ với chúng tôi để được hỗ trợ.': 'Sorry, there were some technical issues while processing your request. Please wait 5 minutes and try again or contact us.',
    'Chưa đủ thông tin để sử dụng chức năng Cho phép Nhà tuyển dụng tìm kiếm hồ sơ đính kèm. Cập nhật thông tin tại': 'Not enough information to use the function Allow Employers to search attached CV. Update information at',
    'Chưa đủ thông tin để sử dụng chức năng Cho phép Nhà tuyển dụng tìm kiếm hồ sơ vừa tải lên. Cập nhật thông tin tại': 'Not enough information to use the function Allow Employers to search CV just uploaded. Update information at',
    'Hiện tại bạn không thể bật chức năng tìm kiếm hồ sơ vì nhập sai thông tin liên hệ. Vui lòng liên hệ với Vietnamworks để xác nhận lại thông tin qua email:': 'Your searchable CV is disable now because of wrong contact information. Please contact with Vietnamworks to verify your information by email:',
    'Xác nhận ứng tuyển': 'Application confirmation',
    'Cấp bậc hiện tại của bạn': 'Your current job level',
    'chưa phù hợp với yêu cầu công việc này': ' is not matching to this job requirement',
    'Bạn có muốn tiếp tục nộp đơn?': 'Do you want to continue to apply?',
    'Tôi đồng ý với': 'I agree to the',
    'Quy định bảo mật': 'Privacy Policy',
    'của nhà tuyển dụng này.': 'of this employer.',
    'Vui lòng đánh dấu vào hộp chọn để tiếp tục nộp đơn.': 'Please tick the checkbox if you want to proceed.'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
